import React from 'react';
import deepEqual from "deep-equal";

interface IProps {
    propsToCheck: any[];
}

interface IState {
}

export default class StopUpdateComponent extends React.Component<IProps, IState> {

    public shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {
        return !deepEqual(this.props.propsToCheck, nextProps.propsToCheck);
    }

    render() {
        return this.props.children
    }
}